import React, { useState } from 'react';
import * as yup from 'yup';
import { useToast } from '../../Components/Others/ToastServices';
import { useFormik } from 'formik';
import axiosInstance from '../../Services/axiosCommon';
import { NuUpload } from '../../Components/Utils/Input'
import DownloadIcon from '../Icons/Download';
import { formatDate } from './NuDate';
import Item from 'antd/es/list/Item';

const ImportFileModal = ({ 
  show,
  onClose,
  getData,
  apiUrl,
  menuName = "File",
  additional_details_req = false,
  url = "",
  required_columns = []
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const [showDownloadConfirm, setShowDownloadConfirm] = useState(false);

  // const formik = useFormik({
  //   initialValues: {
  //     file: null,
  //   },
  //   validationSchema: yup.object({
  //     file: yup.mixed().required(`Please upload a File`),
  //   }),
  //   onSubmit: async (values, { resetForm }) => {
  //     setIsLoading(true);
  //     let formData = new FormData();
  //     formData.append('file', values.file);

  //     await axiosInstance.post(apiUrl, formData)
  //       .then(res => {
  //         if (res.data) {
  //           resetForm();
  //           onClose();
  //           getData();
  //           toast.open({
  //             type: "success",
  //             message: `Imported successfully`,
  //           });
  //         } else {
  //           setIsLoading(false);
  //           toast.open({
  //             type: "error",
  //             message: `Import failed`,
  //           });
  //         }
  //       })
  //       .catch(err => {
  //         setIsLoading(false);
  //         toast.open({
  //           type: "error",
  //           message: `Import failed`,
  //         });
  //       });
  //   }
  // });



  // Define exportValue with default values
  const [exportValue] = useState({
    status: "",
    assigneeId: "",
    dateFrom: "",
    dateTo: ""
  });

  const formik = useFormik({
    initialValues: {
      file: null,
    },
    validationSchema: yup.object({
      file: yup.mixed().required(`Please upload a File`),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      let formData = new FormData();
      formData.append("file", values.file);

      try {
        const res = await axiosInstance.post(apiUrl, formData);

        if (res.data) {
          resetForm();
          onClose();
          getData();
          toast.open({
            type: "success",
            message: `Imported successfully`,
          });
        } else {
          setIsLoading(false);
          toast.open({
            type: "error",
            message: `Import failed`,
          });
        }
      } catch (err) {
        setIsLoading(false);

        const errorType = err.response?.data?.error || "";
        const errorMsg =
          err.response?.data?.msg ||
          err.response?.data?.message ||
          "Import failed";

        // If backend error is "Missing columns", show warning
        if (errorType === "Missing columns") {
          toast.open({
            type: "warning",
            message: `${errorType} : ${errorMsg}`,
          });
        } else {
          toast.open({
            type: "error",
            message: errorMsg,
          });
        }
      }
    },
  });

  const ImportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      try {
        const response = await axiosInstance.get(
          `${url}`,
          {
            responseType: "blob",
          }
        );

        const pdfBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
     link.download = `${menuName} ${formatDate(new Date())}.xlsx`;


        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      }
    },
  });

  const handleFileChange = (e) => {
    if (e.target.files.length) {
      formik.setFieldValue("file", e.target.files[0]);
    }
  };

  if (!show) return null;


const cancelDownload = () => {
  setShowDownloadConfirm(false);
};

const confirmDownload = async () => {
  setShowDownloadConfirm(false);

  try {
    // Call ImportFormik submit or your download logic here
    await ImportFormik.handleSubmit();
  } catch (error) {
    console.error("Download failed", error);
  }
};

  

  return (
    <>
      <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
        <div className="animate-scale-in min-w-[90%] sm:min-w-[40%] max-w-[70%] max-h-[80vh] bg-white py-6 px-6 rounded-md shadow-lg overflow-y-scroll">
          <form onSubmit={formik.handleSubmit}>
            <div className="w-full">
              <NuUpload
                label={`Import  ${menuName}`}
                width="w-full"
                onChange={handleFileChange}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
              />
              {formik.errors.file && formik.touched.file && (
                <p className="text-red-500 text-xs font-medium mt-1 ml-7">{formik.errors.file}</p>
              )}

              {additional_details_req && (
                <div className="flex gap-4 px-6 py-2 justify-between items-baseline text-xs 2xl:text-sm">
                <div>
                  <p> <span className=' text-red-600'>*</span>Req. Columns</p>
                  <ul className="list-disc pl-6 mt-2">
                    {required_columns.length>0 && required_columns.map((Item)=>{
                      return(
                        <li>{Item}</li>
                      )
                    })}
                  </ul>
                </div>

                <div className="relative group inline-block">
                  <button
  type="button"
  onClick={() => setShowDownloadConfirm(true)}
  className="text-red-500 cursor-pointer border-none"
>
  <DownloadIcon />
</button>

                  <span className="absolute left-[-10px] -translate-x-1/2 bottom-full mb-2 w-max px-2 py-1 text-xs text-white bg-red-600 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                    Download sample file
                  </span>
                </div>
              </div>
            )}

              <div className="flex gap-4 justify-center items-baseline">
                <button
                  type="submit"
                  className={`px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm rounded-lg mt-4 text-center flex items-center justify-center gap-2 ${
                    isLoading ? "bg-red-300 cursor-wait" : "bg-baseColor-primary"
                  } text-white`}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <svg
                        className="animate-spin h-4 w-4 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 100 16v-4l-3 3 3 3v-4a8 8 0 01-8-8z"
                        />
                      </svg>
                      Importing...
                    </>
                  ) : (
                    "Import"
                  )}
                </button>

                <button
                  type="button"
                  onClick={() => onClose()}
                  className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm text-textColor-main bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center"
                >
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

       {showDownloadConfirm && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <h3 className="text-sm font-medium mb-4">Warning</h3>
            <p className="mb-6 text-xs">
              Are you sure you want to download this sample <b>Xlsx</b> file?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={cancelDownload}
                className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md bg-[#E6F2F2] text-textColor-main"
              >
                No
              </button>
              <button
                onClick={confirmDownload}
                className="px-4 py-[8px] text-xs bg-textColor-main rounded-md text-white hover:opacity-90"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ImportFileModal;